import Vue from 'vue'
import Router from 'vue-router'

// import ClientPriority from './views/ClientPriority.vue'
import ClientGender from './views/ClientGender.vue'
// import ClientChoose from './views/ClientChoose.vue'
import ClientService from './views/ClientService.vue'
import ClientMasters from './views/ClientMasters.vue'
import ClientConfirm from './views/ClientConfirm.vue'
import ClientEnd from './views/ClientEnd.vue'
import ClientCompany from './views/ClientCompany.vue'
import ErrorPage from './views/ErrorPage.vue'

// export default new Router({
const VueRouter = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'client-home',
    //   component: ClientHome,
    //   meta: { title: 'Client Home' }
    // },
    {
      path: '/company/:cid',
      name: 'client-company',
      component: ClientCompany,
      meta: { title: 'Выбор филиала' },
      props: true,
      },
    // {
    //   path: '/company/:cid/client-priority',
    //   name: 'client-priority',
    //   component: ClientPriority,
    //   meta: { title: 'Client Priority' },
    //   props: true,
    // },
    {
      path: '/company/:cid/:sid([0-9]*)/client-gender',
      name: 'client-gender',
      component: ClientGender,
      meta: { title: 'Выбор пола' },
      props: true,
    },
    // {
    //   path: '/company/:cid/client-choose',
    //   name: 'client-choose',
    //   component: ClientChoose,
    //   meta: { title: 'Client Choose' },
    //   props: true,
    // },
    {
      path: '/company/:cid/:sid([0-9]*)/client-service',
      name: 'client-service',
      component: ClientService,
      meta: { title: 'Выбор услуги' },
      props: true,
    },
    {
      path: '/company/:cid/:sid([0-9]*)/client-masters',
      name: 'client-masters',
      component: ClientMasters,
      meta: { title: 'Выбор мастера' },
      props: true,
    },
    {
      path: '/company/:cid/:sid([0-9]*)/client-confirm',
      name: 'client-confirm',
      component: ClientConfirm,
      meta: { title: 'Подтверждение записи' },
      props: true,
    },
    {
      path: '/company/:cid/:sid([0-9]*)/client-end',
      name: 'client-end',
      component: ClientEnd,
      meta: { title: 'Запись успешно создана' },
      props: true,
    },
    {
      path: '*',
      name: 'error',
      components: {
        error: ErrorPage
      },
      meta: { title: 'Страница не найдена' },
      props: true,
    }
  ]
});
export default VueRouter

Vue.use(Router)
VueRouter.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
});
